import * as iframeActions from 'client/common/store/actions/iframe';

import {checkIsOpenedInFrame} from 'client/common/utils/iframe';

import {call, takeEvery} from 'redux-saga/effects';

export function sendPostMessage(data: any) {
    data = JSON.stringify(data);
    window.parent.postMessage(data, '*');
}

export function* checkAndSend(action: iframeActions.SendMessageAction) {
    const isOpenedInFrame: ReturnType<typeof checkIsOpenedInFrame> = yield call(
        checkIsOpenedInFrame
    );

    if (isOpenedInFrame) {
        yield call(sendPostMessage, action.payload);
    }
}

export default function* router() {
    yield takeEvery(iframeActions.SEND_MESSAGE, checkAndSend);
}
